import { computed, ComputedRef } from 'vue';
import { NetType } from '@/constants';
import { useRoute } from 'vue-router';
export const platformTypes = [
  { label: 'Snapshot', value: 'snapshot' },
  { label: 'Aragon App', value: 'aragon_app' },
  { label: 'Aragon Client', value: 'aragon_client' },
  { label: 'Aragon Tao', value: 'aragon_tao' },
  { label: 'XDAO', value: 'xdao' },
  { label: 'Colony', value: 'colony' },
  {
    label: 'Tally',
    value: 'tally',
  },
  { label: 'Nouns', value: 'nouns' },
  { label: 'Partydao', value: 'partydao' },
  { label: 'Compound', value: 'compound' },
  { label: 'Openzeppelin', value: 'openzeppelin' },
  { label: 'Homebase', value: 'homebase' },
  { label: 'Moloch', value: 'moloch' },

  { label: 'Other', value: 'other' },
];
export const typeType = [
  { label: 'NFT', value: '0' },
  { label: 'FT', value: '1' },
];

export const NetworkType = [
  { label: 'Ethereum', value: NetType.ethereum },
  {
    label: 'Polygon',
    value: NetType.matic,
  },
  {
    label: 'Optimism',
    value: NetType.optimism,
  },
  {
    label: 'Arbitrum',
    value: NetType.arbitrum,
  },

  {
    label: 'Ronin',
    value: NetType.ronin,
  },
  {
    label: 'Tezos',
    value: NetType.tezos,
  },
  {
    label: 'Gnosis',
    value: NetType.gnosis,
  },
  {
    label: 'Algorand',
    value: NetType.algorand,
  },
  {
    label: 'Base',
    value: NetType.base,
  },
  {
    label: 'BNB',
    value: NetType.bsc,
  },
];

export const TagType = [
  { label: 'Treasury', value: 'Treasury' },
  { label: 'Governance', value: 'Governance' },
  { label: 'Token', value: 'Token' },
];

export const passTypeMap = {
  fixed_price: 'fp',
  bonding_curve: 'bc',
  staking_based: 'sb',
};

export const useIsEditDao = (): ComputedRef<any> => {
  const $route = useRoute();
  return computed(() => !!$route.params.name);
};
